/* eslint-disable consistent-return */
import Grid from '@config/Grid/Grid'
import Tile from '@/shared/components/Tile/Tile'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from '@/features/feedback/FeedbackPage.module.scss'
import FeedbackSummary from '@/features/feedback/components/FeedbackSummary/FeedbackSummary'
import FeedbackTile from '@/features/feedback/components/FeedbackTile/FeedbackTile'
import IconButton from '@/shared/components/IconButton/IconButton'
import DatePicker from '@/shared/components/DatePicker/DatePicker'

function FeedbackPage() {
  const { t } = useTranslation()
  const pageContainerRef = useRef<HTMLDivElement>(null)
  const [isExpanded, setIsExpanded] = useState(false)

  const handleExpandClick = () => {
    if (pageContainerRef.current) {
      if (!isExpanded) {
        pageContainerRef.current.scrollTo({
          top: pageContainerRef.current.scrollHeight,
          behavior: 'smooth'
        })
      } else {
        pageContainerRef.current.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
      setIsExpanded(!isExpanded)
    }
  }

  useEffect(() => {
    const el = pageContainerRef.current
    if (!el) return

    let last = el.scrollTop

    const handleScroll = () => {
      const { scrollTop, clientHeight, scrollHeight } = el

      const atBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight
      const scrolledUp = scrollTop < last

      if (!isExpanded && atBottom) {
        setIsExpanded(true)
      } else if (isExpanded && scrolledUp) {
        setIsExpanded(false)
      }

      last = scrollTop
    }

    el.addEventListener('scroll', handleScroll)
    return () => el.removeEventListener('scroll', handleScroll)
  }, [isExpanded])

  return (
    <Grid>
      <div
        className={`${styles.feedbackPageWrapper} start-2 col-11`}
      >
        <Tile color="black">
          <div className={styles.feedbackPageContainer} ref={pageContainerRef}>
            <div className={styles.feedbackHeaderContainer}>
              <div
                id="tour-feedback-content"
                className={styles.feedbackHeaderLeftWrapper}
              >
                <p className={`${styles.feedbackHeader} title-bold-medium`}>
                  {t('FEEDBACK.TITLE')}
                </p>
                <div className={styles.feedbackDescriptionContainer}>
                  <p className={`${styles.feedbackDescription} title-large`}>
                    87% positive feedback.
                  </p>
                  <p
                    className={`${styles.feedbackDescriptionSmall} title-small`}
                  >
                    Most customers rated their overall experience as great.
                  </p>
                  <p
                    className={`${styles.feedbackDescriptionSmall} title-small`}
                  >
                    Compared to last week:{' '}
                    <mark className="mark-white">+5%</mark>
                  </p>
                </div>
              </div>
              <FeedbackSummary />
            </div>
            <div className={styles.feedbackTilesWrapper}>
              <div className={styles.feedbackTilesHeader}>
                <div className={styles.feedbackTilesHeaderLeftSideItems}>
                  <DatePicker label={t('COMMON.DATE_RANGE')} />
                  {/* <TooltipButton icon="las la-filter icon-big">
                    test
                  </TooltipButton>
                  <TooltipButton icon="las la-user-circle icon-big">
                    test
                  </TooltipButton> */}
                </div>
                <IconButton
                  icon={
                    isExpanded
                      ? 'las la-compress icon-big'
                      : 'las la-expand icon-big'
                  }
                  onClick={handleExpandClick}
                  color="primary"
                />
              </div>
              <div className={styles.feedbackTilesContainer}>
                <FeedbackTile
                  foodAndDrinksRating={5}
                  serviceRating={4}
                  ambianceRating={3}
                  date="2024-06-01"
                  message="I had dinner here last night with my family, and overall it was a wonderful experience. The food was fresh, flavorful, and beautifully presented, especially the grilled salmon, which was cooked perfectly. Our server was very polite and attentive, checking on us just enough without being intrusive. The only minor downside was that our appetizers took a little longer than expected to arrive, but the staff apologized and handled it professionally. The ambiance was cozy and welcoming, with just the right amount of background music and warm lighting. We’ll definitely be coming back soon and recommending this place to friends."
                  author="John Doe"
                />
                <FeedbackTile
                  foodAndDrinksRating={5}
                  serviceRating={4}
                  ambianceRating={3}
                  date="2024-06-01"
                  message="I had dinner here last night with my family, and overall it was a wonderful experience. The food was fresh, flavorful, and beautifully presented, especially the grilled salmon, which was cooked perfectly. Our server was very polite and attentive, checking on us just enough without being intrusive. The only minor downside was that our appetizers took a little longer than expected to arrive, but the staff apologized and handled it professionally. The ambiance was cozy and welcoming, with just the right amount of background music and warm lighting. We’ll definitely be coming back soon and recommending this place to friends."
                  author="John Doe"
                />
                <FeedbackTile
                  foodAndDrinksRating={5}
                  serviceRating={4}
                  ambianceRating={3}
                  date="2024-06-01"
                  message="I had dinner here last night with my family, and overall it was a wonderful experience. The food was fresh, flavorful, and beautifully presented, especially the grilled salmon, which was cooked perfectly. Our server was very polite and attentive, checking on us just enough without being intrusive. The only minor downside was that our appetizers took a little longer than expected to arrive, but the staff apologized and handled it professionally. The ambiance was cozy and welcoming, with just the right amount of background music and warm lighting. We’ll definitely be coming back soon and recommending this place to friends."
                  author="John Doe"
                />
                <FeedbackTile
                  foodAndDrinksRating={5}
                  serviceRating={4}
                  ambianceRating={3}
                  date="2024-06-01"
                  message="I had dinner here last night with my family, and overall it was a wonderful experience. The food was fresh, flavorful, and beautifully presented, especially the grilled salmon, which was cooked perfectly. Our server was very polite and attentive, checking on us just enough without being intrusive. The only minor downside was that our appetizers took a little longer than expected to arrive, but the staff apologized and handled it professionally. The ambiance was cozy and welcoming, with just the right amount of background music and warm lighting. We’ll definitely be coming back soon and recommending this place to friends."
                  author="John Doe"
                />
                <FeedbackTile
                  foodAndDrinksRating={5}
                  serviceRating={4}
                  ambianceRating={3}
                  date="2024-06-01"
                  message="I had dinner here last night with my family, and overall it was a wonderful experience. The food was fresh, flavorful, and beautifully presented, especially the grilled salmon, which was cooked perfectly. Our server was very polite and attentive, checking on us just enough without being intrusive. The only minor downside was that our appetizers took a little longer than expected to arrive, but the staff apologized and handled it professionally. The ambiance was cozy and welcoming, with just the right amount of background music and warm lighting. We’ll definitely be coming back soon and recommending this place to friends."
                  author="John Doe"
                />
              </div>
            </div>
          </div>
        </Tile>
      </div>
    </Grid>
  )
}

export default FeedbackPage
